import React from "react";
import { DeleteIcon, EditIcon } from "../svgFile";

export const initialNotifications = [
  {
    id: 1,
    title: "Marina Bay Tower",
    subtitle: "28 August 2025",
    date: "28 August 2025",
    image: "/image/recent-image.png",
    icon: null,
    iconType: null,
    isActive: false,
    isRead: false,
  },
  {
    id: 2,
    title: "Skyline Plaza",
    subtitle: "Open for investment now!",
    date: "28 August 2025",
    image: "/image/recent-image.png",
    icon: null,
    iconType: null,
    isActive: true,
    isRead: false,
  },
  {
    id: 3,
    title: "Download Monthly Statement",
    subtitle: "Go to document and download month...",
    date: "28 August 2025",
    image: null,
    icon: <EditIcon />,
    iconType: "edit",
    isActive: false,
    isRead: false,
  },
  {
    id: 4,
    title: "New Contract to be added",
    subtitle: "Go to document and download new co...",
    date: "28 August 2025",
    image: null,
    icon: <DeleteIcon />,
    iconType: "delete",
    isActive: false,
    isRead: false,
  },
  {
    id: 5,
    title: "Marina Bay Tower",
    subtitle: "Now open for funding – 65% already...",
    date: "28 August 2025",
    image: "/image/recent-image.png",
    icon: null,
    iconType: null,
    isActive: false,
    isRead: false,
  },
];